import React from 'react'
import JournalView from './components/JournalView.js'

function Journal() {
  return (
    <><JournalView /></>
  )
}

export default Journal